<template>
  <v-container fluid v-if="$route.name === 'reports'">
    <v-layout>
      <v-flex xs12>
        <p>Выберите учебный год</p>
      </v-flex>
    </v-layout>
  </v-container>
  <router-view v-else></router-view>
</template>

<script>
export default {
  data: () => ({})
}
</script>
